<template>
  <li>
    <SmartLink
      ref="menuItemLink"
      class="mobile-menu-button"
      :url="item.url"
      :target="item.target"
      :route="item.route"
      :method="item.method"
      :event="item.event"
      @click="handleClick"
    >
      <div class="mobile-menu-button__content">
        <component :is="item.icon" />
        {{ item.name }}
        <OpenDownIcon
          v-if="item.subitems"
          :class="clsx('mobile-main-menu-open-icon', { 'mobile-main-menu-open-icon__active': isActive })"
        />
      </div>
      <div :class="clsx('nested-mobile-menu-list-wrapper', { 'nested-mobile-menu-list-wrapper__active': isActive })">
        <slot></slot>
      </div>
    </SmartLink>
  </li>
</template>

<script>
import { clsx } from 'clsx';
import { CheckIcon, OpenDownIcon } from '@/shared/ui/icons';
import { SmartLink } from '@/shared/ui/link';

export default {
  props: {
    item: {
      type: Object,
      default: null,
      required: true,
    }
  },
  data() {
    return {
      isActive: false,
    };
  },
  components: { OpenDownIcon, CheckIcon, SmartLink },
  methods: {
    clsx,
    handleClick(event) {
      if (this.item.subitems) {
        event.preventDefault();
        event.stopPropagation();
        this.isActive = !this.isActive;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.mobile-menu-button {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;

  &__subitems {
    transform: rotate(-90deg);
  }

  &__content {
    display: flex;
    align-items: center;
    color: #09090B;
    white-space: nowrap;
    padding: 8px 0 8px 8px;

    &:hover {
      background-color: #D4D4D8;
      border-radius: 6px;
    }
  }
}

.mobile-main-menu-open-icon {
  margin-left: auto;
  transform: rotate(-90deg);
  transition: transform 0.3s ease;

  &__active {
    transform: rotate(0deg);
  }
}

.nested-mobile-menu-list-wrapper {
  display: none;

  &__active {
    display: block;
  }
}
</style>
